import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../../design/dialog";
import { Table, TableBody, TableCell, TableRow } from "../../../design/table";

interface SelectLanguageDialogProps {
  isOpen: boolean;
  onLanguageSelected: (language: string) => void;
  onClose: () => void;
}

const supportedLanguages: string[] = [
  "English",
  "Spanish",
  "Mandarin",
  "Hindi",
  "Arabic",
  "Portuguese",
  "Bengali",
  "Russian",
  "French",
  "German",
  "Japanese",
  "Korean",
  "Vietnamese",
  "Italian",
  "Polish",
  "Turkish",
  "Persian",
  "Tagalog",
  "Other",
];

const SelectLanguageDialog: React.FC<SelectLanguageDialogProps> = ({
  isOpen,
  onClose,
  onLanguageSelected,
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle className="flex items-center justify-between">
        Select Language
      </DialogTitle>
      <DialogBody>
        <Table>
          <TableBody>
            {supportedLanguages.map((language) => (
              <TableRow
                key={language}
                onClick={() => onLanguageSelected(language)}
              >
                <TableCell className="font-bold">{language}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogBody>
      <DialogActions className="justify-between" />
    </Dialog>
  );
};

export default SelectLanguageDialog;
